// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card.contentcard {
  background-color: #fff !important;
}
ion-card.contentcard ion-card {
  box-shadow: none;
  position: fixed;
  z-index: 999;
  overflow: hidden;
  min-width: 100%;
}
ion-card.contentcard ion-card ion-searchbar.custom {
  padding: 20px;
  max-height: 45px;
  border: 1px solid var(--ion-color-primary);
  border-radius: 12px;
}
ion-card.contentcard ion-list {
  margin-top: 50px;
}
ion-card.contentcard ion-list ion-item {
  --padding-start: 4px;
  --padding-end: 4px;
  --inner-padding-end: 4px;
  --inner-padding-start: 4px;
}
ion-card.contentcard ion-list ion-item ion-label {
  padding: 10px;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/area-lists/area-lists.page.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;AACJ;AAAI;EACI,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAER;AAAQ;EACI,aAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;AAEZ;AAEI;EACI,gBAAA;AAAR;AAEQ;EACI,oBAAA;EACA,kBAAA;EACA,wBAAA;EACA,0BAAA;AAAZ;AAGY;EACI,aAAA;EACA,eAAA;AADhB","sourcesContent":["ion-card.contentcard {\n    background-color: #fff !important;\n    ion-card {\n        box-shadow: none;\n        position: fixed;\n        z-index: 999;\n        overflow: hidden;\n        min-width: 100%;\n\n        ion-searchbar.custom {\n            padding: 20px;\n            max-height: 45px;\n            border: 1px solid var(--ion-color-primary);\n            border-radius: 12px;\n        }\n    }\n\n    ion-list {\n        margin-top: 50px;\n\n        ion-item {\n            --padding-start: 4px;\n            --padding-end: 4px;\n            --inner-padding-end: 4px;\n            --inner-padding-start: 4px;\n\n            //font-size: 0.9em;\n            ion-label {\n                padding: 10px;\n                font-size: 16px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
